<template>
	<Spin size="large" v-if="isShow" fix>
	<Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
	<div><slot>Loading</slot></div>
	</Spin>
</template>
<script>
export default {
	name: 'load',
	data () {
		return {
			isShow:true
		}
	},
	methods: {
		spinShow(){
			this.isShow = true;
		},
		spinHide(){
			this.isShow = false;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inc/component/load.vue